import { Link, useParams } from 'react-router-dom';
import { useGetMyGroupsQuery, useStartGroupTelegramLinkMutation } from '../../../api/subscribeApi';
import { useToast } from '../../../context/ToastContext';
import { errMsg } from '../../../utils/errMsg';
import getSubdomain from '../../../utils/getSubdomain';
import GroupTile from '../../../components/GroupTile/GroupTile';
import card from '../../../styles/shared/publicCard.module.css';
import styles from './MyGroupsPage.module.css';

export default function MyGroupsPage() {
  const { organizationSlug: slugFromPath } = useParams();
  const subdomainSlug = getSubdomain();
  const organizationSlug = slugFromPath ?? subdomainSlug;
  const loginPath = '/subscriber/login';
  const showToast = useToast();

  const { data, isLoading, isError, error } = useGetMyGroupsQuery(organizationSlug);
  const [startGroupTelegramLink, { isLoading: isLinkingChat }] = useStartGroupTelegramLinkMutation();

  async function handleMessageGroup(groupId) {
    try {
      const { deep_link_url: deepLinkUrl } = await startGroupTelegramLink({
        organizationSlug,
        groupId,
      }).unwrap();
      window.open(deepLinkUrl, '_blank', 'noopener,noreferrer');
    } catch (err) {
      showToast('error', 'Groups', errMsg(err, 'Could not open the group chat.'));
    }
  }

  if (isLoading) return <p className={card.status}>Loading…</p>;
  if (isError) {
    return (
      <div className={card.centeredPage}>
        <p className={card.status}>
          {error?.status === 401
            ? 'Your session expired.'
            : 'Could not load your groups. Please try again.'}
        </p>
        <Link to={loginPath}>Log in</Link>
      </div>
    );
  }

  const groups = [];
  const groupsById = new Map();
  for (const { group, subscription } of data?.groups ?? []) {
    let entry = groupsById.get(group.id);
    if (!entry) {
      entry = { group, hasTelegram: false };
      groupsById.set(group.id, entry);
      groups.push(entry);
    }
    if (subscription.channel === 'telegram') entry.hasTelegram = true;
  }

  return (
    <div className={styles.pageWrapper}>
      <div className={styles.header}>
        <h1 className={styles.title}>My groups</h1>
      </div>

      {groups.length ? (
        <div className={styles.grid}>
          {groups.map(({ group, hasTelegram }) => (
            <GroupTile key={group.id} imageUrl={group.tile_image_url} name={group.name}>
              {!group.broadcast && hasTelegram && (
                <button
                  type="button"
                  className={styles.chatIconBtn}
                  onClick={() => handleMessageGroup(group.id)}
                  disabled={isLinkingChat}
                  aria-label="Message this group"
                >
                  <i className="pi pi-comments" />
                </button>
              )}
            </GroupTile>
          ))}
        </div>
      ) : (
        <p className={card.status}>You&apos;re not subscribed to any groups yet.</p>
      )}
    </div>
  );
}
